import axios from 'axios';

// Endpoints PHP sur le même domaine. On garde le chemin relatif + l'extension
// .php explicite : pas de dépendance à MultiViews côté Apache.
const api = axios.create({ baseURL: '/api', timeout: 12000 });

export class FfttService {
  async fetchEquipes(twoLast = false) {
    try {
      const response = await api.get('/fftt-equipes.php', { params: { twoLast } });
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching equipes:', error);
      return [];
    }
  }

  async fetchMatchs(liendivision) {
    try {
      const response = await api.get('/fftt-matchs.php', { params: { ...liendivision } });
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching matchs:', error);
      return [];
    }
  }

  async fetchJoueursByPoints(topThree = false) {
    try {
      const response = await api.get('/fftt-joueurs.php', { params: { topThree } });
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching joueurs by points:', error);
      return [];
    }
  }
}
